import React from "react";
import { motion } from "framer-motion";
import { Boxes, FileText, Ship, ClipboardCheck, Radar, PackageCheck, ArrowRight } from "lucide-react";
import { Reveal, easeOut } from "./primitives";

const NODES = [
  { icon: Boxes, label: "BulkContainer™", accent: true },
  { icon: FileText, label: "Purchase Order" },
  { icon: Ship, label: "FreightIQ™" },
  { icon: ClipboardCheck, label: "Inspection™" },
  { icon: Radar, label: "Live Shipment Tracking™" },
  { icon: PackageCheck, label: "Delivered", success: true },
];

export default function ConnectedWorkspace() {
  return (
    <section className="relative overflow-hidden bg-[#0A1128] py-24 md:py-32">
      <div className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[900px] -translate-x-1/2 rounded-full bg-[#0052FF]/25 blur-[130px]" aria-hidden />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <Reveal>
          <div className="mx-auto max-w-3xl text-center">
            <span className="font-mono-ui text-[11px] font-semibold uppercase tracking-[0.2em] text-[#60A5FA]">
              Connected Workspace
            </span>
            <h2 className="font-display mt-4 text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-[2.75rem] lg:leading-[1.1]">
              One ecosystem, end to end.
            </h2>
            <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-slate-300 sm:text-lg">
              BulkContainer™ connects natively with the DeMaxtore Workspace ecosystem — so your
              order flows seamlessly from purchase to delivery.
            </p>
          </div>
        </Reveal>

        <div className="mt-16 flex flex-col items-stretch gap-4 lg:flex-row lg:items-center lg:justify-center">
          {NODES.map((n, i) => (
            <React.Fragment key={n.label}>
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, ease: easeOut, delay: i * 0.1 }}
                data-testid={`ecosystem-node-${i}`}
                className={`flex flex-1 items-center gap-3 rounded-2xl border px-4 py-4 backdrop-blur-sm lg:flex-col lg:gap-3 lg:px-3 lg:py-6 lg:text-center ${
                  n.accent
                    ? "border-[#0052FF]/40 bg-[#0052FF]/[0.12]"
                    : n.success
                    ? "border-[#10B981]/30 bg-[#10B981]/[0.08]"
                    : "border-white/10 bg-white/[0.04]"
                }`}
              >
                <span
                  className={`flex h-11 w-11 items-center justify-center rounded-xl ${
                    n.accent ? "bg-[#0052FF] text-white" : n.success ? "bg-[#10B981] text-white" : "bg-white/10 text-slate-200"
                  }`}
                >
                  <n.icon className="h-5 w-5" />
                </span>
                <span className="text-[13px] font-semibold leading-tight text-white">{n.label}</span>
              </motion.div>
              {i !== NODES.length - 1 && (
                <ArrowRight className="mx-auto h-4 w-4 rotate-90 shrink-0 text-slate-600 lg:rotate-0" />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}
